import { SET_PAGINATION, TOGGLE_PROGRESS } from "../actionTypes";

const initialState = {
  limit: 1,
  page: 1,
  pages: 1,
  total: 120,
  progressBar: false,
};

export default function pagination(state = initialState, action) {
  switch (action.type) {
    case SET_PAGINATION:
      const { limit, page, pages, total } = action.payload;
      return {
        ...state,
        limit: limit,
        page: page,
        pages: pages,
        total: total,
      };
    case TOGGLE_PROGRESS:
      return {
        ...state,
        progressBar: action.payload,
      };
    default:
      return state;
  }
}
